/** @jsxImportSource @emotion/react */

import styled from "@emotion/styled";
import { useState, useEffect } from "react";
import { Layer, CollageLayer } from "./Layer";
import React from "react";
import Button from "@material-ui/core/Button";

import { SortableContainer } from "react-sortable-hoc";
import arrayMove from "array-move";

import PerfectScrollbar from "react-perfect-scrollbar";

import { useStoreon } from "storeon/react";
import t from "translations";

const LayersWrapper = styled.ul`
  padding: 0px;
  margin: 0px;
`;

const LayersList = SortableContainer(({ items }) => {
  return (
    <LayersWrapper>
      {items.map((object, index) => {
        if (object.type === "collage") {
          return (
            <CollageLayer key={`item-${index}`} index={index} obj={object} />
          );
        } else {
          return <Layer key={`item-${index}`} index={index} obj={object} />;
        }
      })}
    </LayersWrapper>
  );
});

const Layers = () => {
  const { canvas, isAdmin, dispatch } = useStoreon(
    "editorType",
    "cachePool",
    "canvas",
    "isAdmin"
  );

  useEffect(() => {
    if (!canvas) return;
    const layerChanges = () => {
      setItems([...getCollageObject(canvas), ...getLayerObjects(canvas)]);
    };

    const getCollageObject = (c) => {
      const maskObjects = c
        .getObjects()
        .filter((obj) => !obj.excludeFromExport && obj.mask);
      if (!maskObjects.length) {
        return [];
      }
      const collageImages = c
        .getObjects()
        .filter((obj) => !obj.excludeFromExport && obj.id && obj.clipId)
        .reverse();
      return [
        {
          type: "collage",
          images: collageImages,
          canvas,
        },
      ];
    };

    const getLayerObjects = (c) => {
      if (isAdmin) {
        return c
          .getObjects()
          .filter((obj) => !obj.excludeFromExport && obj.id)
          .reverse();
      }
      return c
        .getObjects()
        .filter(
          (obj) =>
            !obj.excludeFromExport &&
            obj.id &&
            !obj.mask &&
            !obj.clipId &&
            !obj.isAdminLocked
        )
        .reverse();
    };
    canvas.on("object:added", layerChanges);
    canvas.on("object:removed", layerChanges);
    canvas.on("object:modified", layerChanges);
    canvas.on("selection:cleared", layerChanges);
    canvas.on("selection:created", layerChanges);
    canvas.on("selection:updated", layerChanges);
    canvas.on("zindex:updated", layerChanges);
    layerChanges();
    return () => {
      canvas.off("object:added", layerChanges);
      canvas.off("object:removed", layerChanges);
      canvas.off("object:modified", layerChanges);
      canvas.off("selection:cleared", layerChanges);
      canvas.off("selection:created", layerChanges);
      canvas.off("selection:updated", layerChanges);
      canvas.off("zindex:updated", layerChanges);
    };
  }, [canvas, isAdmin]);

  const [items, setItems] = useState([]);

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const newOrder = arrayMove(items, oldIndex, newIndex);
    canvas.DPE.layers.updateOrder(newOrder.reverse());
  };

  const handleNewCanvasClick = (collage) => dispatch("canvas/clear");

  if (!canvas) return null;

  return (
    <React.Fragment>
      <Button
        variant="contained"
        fullWidth
        onClick={handleNewCanvasClick}
        style={{ marginBottom: 10 }}
      >
        {t.clear}
      </Button>
      <PerfectScrollbar>
        <LayersList items={items} onSortEnd={onSortEnd} distance={15} />
      </PerfectScrollbar>
    </React.Fragment>
  );
};

export default Layers;
